const resources = {
    searchResults: 'Résultats de recherche',
    sale: 'Solde'
};

module.exports = function getResource(label) {
    return resources[label];
};
